import { render, staticRenderFns } from "./DropdownAnswer.vue?vue&type=template&id=e4e8a058&"
import script from "./DropdownAnswer.vue?vue&type=script&lang=js&"
export * from "./DropdownAnswer.vue?vue&type=script&lang=js&"
import style0 from "./DropdownAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports